import React from "react";
import TitleHeader from "../../global/TitleHeader";
import NewsLetter from "../home/NewsLetter";
import Products from "../home/Products";

const ProductIndex = () => {
  return (
    <div>
      <TitleHeader
        title="Our Products"
        description="Explore our range of durable, lightweight, and customizable thermocol packaging products."
      />
      <Products />
      <NewsLetter />
    </div>
  );
};

export default ProductIndex;
